<div
  *ngIf="!loading && isLoggedIn"
  #projectLoggedFrame
  class="layout-wrapper"
  [ngClass]="{
    'p-input-filled': inputStyle === 'filled',
    'p-ripple-disabled': !ripple,
    'layout-menu-static': isStatic(),
    'layout-menu-overlay': isOverlay(),
    'layout-menu-horizontal': isHorizontal(),
    'layout-menu-slim': isSlim(),
    'layout-menu-active': menuActive,
    'layout-menu-mobile-active': mobileMenuActive,
    'layout-topbar-mobile-active': mobileTopbarActive,
    'layout-rightmenu-active': rightMenuActive,
    'layout-rtl': isRTL,
    'layout-visible-top-bar': isTopBarVisible(),
    'layout-hidden-top-bar': isTopBarHidden()
  }"
  [class]="'layout-menu-' + menuTheme + ' layout-topbar-' + topbarTheme"
>
  <viggo-core-toolbar
    (onMenuButtonClick)="firstContact ? null : onMenuButtonClick($event)"
    (onTopbarMobileButtonClick)="onTopbarMobileButtonClick($event)"
    [appName]="appName"
    [logoToolBar]="logoToolBar"
    [mobileTopbarActive]="mobileTopbarActive"
    [showFastMenu]="!firstContact && menuFast.length !== 0"
    [menuProfile]="menuProfile"
    [menuFast]="menuFast"
    [showMenuLeft]="!firstContact"
  >
  </viggo-core-toolbar>
  <div class="menu-wrapper" *ngIf="!firstContact" (click)="onMenuClick($event)">
    <div class="layout-menu-container">
      <viggo-core-menu
        [menuItem]="menuItem"
        [isOverlay]="isOverlay()"
        [isHorizontal]="isHorizontal()"
        [isSlim]="isSlim()"
        [isMobile]="isMobile()"
        [isDesktop]="isDesktop()"
        [isStatic]="isStatic()"
      >
      </viggo-core-menu>
    </div>
  </div>

  <div class="layout-main" style="margin-left: 0 !important;">
    <viggo-core-header>
      <viggo-core-breadcrumb
        [disabledRoot]="firstContact"
        [disableAllBreadCrumb]="firstContact"
        [useIcons]="true"
      ></viggo-core-breadcrumb>
    </viggo-core-header>
    <div
      class="layout-content bg-white"
      [ngClass]="{ 'bg-content-error': firstContact && !isUserAdmin }"
    >
      <router-outlet></router-outlet>
      <div class="button-float-right" *ngIf="showFab()">
        <button
          class="cart-button"
          mat-fab
          [pTooltip]="getTooltipFab()"
          (click)="actionFab()"
        >
          <i [class]="iconFab()"></i>
        </button>
      </div>
      <div class="button-float-right" *ngIf="showFabVersion()">
        <button
          class="cart-button"
          mat-fab
          pTooltip="Atualização de sistema"
          (click)="updateVersion()"
        >
          <i class="pi pi-fw pi-sparkles"></i>
        </button>
      </div>
    </div>

    <viggo-core-footer
      [logoApp]="'assets/images/logo-viggo.png'"
    ></viggo-core-footer>
    <!--
    [whatsApp]="{show: true, link: 'https://web.whatsapp.com/'}"
    [instagram]="{show: true, link: 'https://www.instagram.com/viggosistemas/'}"
    [facebook]="{show: true, link: 'https://www.facebook.com/search/top?q=viggo%20sistemas'}" -->
  </div>
</div>
<div class="app-loading bg-primary" *ngIf="loading">
  <h4 class="text-splash">
    Estamos carregando um mundo completo todinho para você!
  </h4>
  <div class="content-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke-width="2"
        stroke-miterlimit="10"
      />
    </svg>
  </div>
</div>
